const cache = new Map<string, string>()
const inflight = new Map<string, Promise<string>>()

export function censorGiftText(input: string): string | Promise<string> {
  if (!input) {
    return input
  }

  const cached = cache.get(input)
  if (cached !== undefined) {
    return cached
  }

  const pending = inflight.get(input)
  if (pending) {
    return pending
  }

  const request = fetch('/api/virtual-gift/censor', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ text: input }),
  })
    .then(async (response) => {
      if (!response.ok) {
        return input
      }

      const data = (await response.json()) as { text?: string }
      return typeof data.text === 'string' ? data.text : input
    })
    .catch(() => input)
    .then((text) => {
      cache.set(input, text)
      inflight.delete(input)
      return text
    })

  inflight.set(input, request)
  return request
}
